import { graphql } from "gatsby";
import React, { Fragment } from "react";
import "./source.scss";

interface Props {
  headline: string;
  sources: string;
}

const Source: React.FC<Props> = props => {
  return <div className="source">
    <h4>{props.headline}</h4>
    <div className="source__content" dangerouslySetInnerHTML={{__html: props.sources}} />
  </div>
}

export default Source;

export const query = graphql`
  fragment SourceBlock on WpAcfSourceBlock {
    AcfBlockSource {
      headline
      sources
    }
  }
`;